import { logger as LOG } from '@garnish/logger';
import { type StripeError } from '@stripe/stripe-js';

LOG.enable('Stripe');
const logger = LOG.extend('Stripe');

LOG.enable('Stripe Error');
const errorLogger = LOG.extend('Stripe Error');

/**
 * Result from attempting to confirm the payment intent.
 * `Stripe | Confirm Result`
 */
function logConfirmResult(result: unknown) {
  logger.info('Confirm Result', result);
}

/**
 * Customer canceled the payment request.
 * `Stripe | Cancelation`
 */
function logCancelation() {
  logger.info('Cancelation');
}

/**
 * Error submitting the elements form from Stripe.
 * `Stripe Error | Submit Error`
 */
function logSubmitError(error?: StripeError | Error) {
  errorLogger.error('Submit Error', error);
}

/**
 * Error creating a payment method from Stripe.
 * `Stripe Error | Create Payment Method Error`
 */
function logCreatePaymentMethodError(error?: StripeError | Error) {
  errorLogger.error('Create Payment Method Error', error);
}

/**
 * Error when confirm is called but Stripe is not initialized.
 * `Stripe Error | Stripe Not Initialized Error`
 */
function logStripeNotInitializedError() {
  errorLogger.error('Stripe Not Initialized Error');
}

/**
 * Error when confirming a payment intent from Stripe.
 * `Stripe Error | Confirm Error`
 */
function logConfirmError(error?: StripeError | Error) {
  errorLogger.error('Confirm Error', error);
}

/**
 * Error when no payment method was created from Stripe.
 * `Stripe Error | No Payment Method Created Error`
 */
function logNoPaymentMethodCreatedError() {
  errorLogger.error('No Payment Method Created Error');
}

/**
 * Generic error during the Stripe flow.
 * Includes failing to create a payment intent (backend call failure).
 * `Stripe Error | Generic Error`
 */
function logGenericError(error?: Error) {
  errorLogger.error('Generic Error', error);
}

// ─── Export ──────────────────────────────────────────────────────────────────

export const StripeLogger = {
  logConfirmResult,
  logCancelation,
  logSubmitError,
  logCreatePaymentMethodError,
  logStripeNotInitializedError,
  logConfirmError,
  logNoPaymentMethodCreatedError,
  logGenericError,
};
